export class AiAdapterDefinition {
    type: string;
    model: string;
    apiKey: string;
    url: string;
}
